import React, { useMemo } from 'react';
import styled from 'styled-components';
import uiSelector from 'services/UI/selectors';
import moment from 'moment';
import { formatDuration } from 'utils/time';
import sand_clock from './sand_clock.svg';

type Props = {
  time?: string;
};

const SandClockBox = ({ time }: Props) => {
  const currentTime = uiSelector.getCurrentTime();
  const countDown = useMemo(() => {
    if (!time) return null;
    const now = moment(currentTime);
    const minutes = now.diff(moment(time, 'hh:mm A'), 'minutes');
    return formatDuration(minutes);
  }, [currentTime, time]);

  return (
    <Container>
      <div className='icon'>
        <img src={sand_clock} alt='sand_clock' style={{ width: 25, height: 24 }} />
      </div>
      <div className='time'>{countDown}</div>
    </Container>
  );
};

export default SandClockBox;

const Container = styled.div`
  display: flex;
  gap: 4px;
  align-items: center;
  .icon {
    display: flex;
    width: 40px;
    height: 40px;
    justify-content: center;
    align-items: center;
    aspect-ratio: 1/1;
  }
  .time {
    color: #d2464f;
    font-size: 24px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
  }
`;
